import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {BrandEnum} from './brand'

export const DetailsTemplateSettingsSchema = buildEntrySchemaFor('detailsTemplateSettings', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      brand: safeOptional(BrandEnum),
      experiments: safeOptional(z.record(z.string(), z.unknown())),
    }),
  ),
})
export type DetailsTemplateSettings = z.infer<typeof DetailsTemplateSettingsSchema>
